import { __read } from "tslib";
import React, { useRef, useState } from 'react';
import { useOnMount } from '@marvelapp/hooks';
import { Button, Flex } from '@marvelapp/ui';
import MessageBlock from '../MessageBlock';
import { Modal } from '../Modal';
import ModalTitle from '../ModalTitle';
import Page from '../Page';
import { InputWithLabel } from '../WithLabel';
export default function CreateGroup(_a) {
    var loading = _a.loading, createGroup = _a.createGroup;
    var _b = __read(useState(''), 2), groupName = _b[0], setGroupName = _b[1];
    var _c = __read(useState(null), 2), errorMessage = _c[0], setErrorMessage = _c[1];
    var inputRef = useRef(null);
    useOnMount(function () { return inputRef.current.focus(); });
    var validateGroupName = function (name) {
        if (name === '') {
            setErrorMessage('Please provide a group name.');
        }
        else {
            createGroup(name);
        }
    };
    return (React.createElement(Page, { title: "Create group" },
        React.createElement(Modal, { closeLink: "/company/groups", maxWidth: 420 },
            React.createElement(ModalTitle, { mb: 5, title: "Create group" }),
            errorMessage && (React.createElement(MessageBlock, { bg: "red", color: "white", mb: 3 }, errorMessage)),
            React.createElement(InputWithLabel, { label: "Group name", mb: 4, onChange: function (event) {
                    setErrorMessage(null);
                    setGroupName(event.target.value);
                }, onKeyDown: function (e) {
                    if (e.key === 'Enter') {
                        validateGroupName(groupName);
                    }
                }, placeholder: "Enter group name", ref: inputRef, size: 3 }),
            React.createElement(Flex, { justifyContent: "flex-start" },
                React.createElement(Button, { "data-testid": "create-group-button", isLoading: loading, kind: "green", onClick: function () { return validateGroupName(groupName); }, size: 3 }, "Create group")))));
}
